import {  ADD_NOTIC_RED, DELETE_NOTIC_RED, GET_NOTIC_RED, UPDATE_NOTIC_RED } from "../Constant";
const initialState = [];
export function NoticReducer(state = initialState, action){
    var newState
    switch (action.type) {
        case ADD_NOTIC_RED:      
           return [...state, action.data];
        case GET_NOTIC_RED:
            return action.data
        case DELETE_NOTIC_RED:
            newState = state.filter(item=>item._id!==action.data._id)
            return newState
        case UPDATE_NOTIC_RED:
            newState = state
            var index = newState.findIndex((item)=>item._id===(action.data._id))
            newState[index] = action.data
            return newState
        default:
            return state
    }
}
